import { theme } from 'antd'
import { FormInput, FormSelect } from 'old/components/form-inputs'
import { FormSection } from 'old/components/form-section/form-section'
import { NotFound, VerticalContainer } from 'old/components/styled'
import { adminLanguageOptions } from 'old/data'
import { Field } from 'react-final-form'
import { NullableField, useTranslate }  from 'old/utils'

type Props = {
    disableEmail: boolean
    hideRest: boolean
}

export const ProfileInfo = ({ disableEmail, hideRest }: Props) => {

    //hooks:
    const { __ } = useTranslate()
    const { token: { marginSM } } = theme.useToken()

    return (
        <FormSection title={__`personal_info`}>

            <VerticalContainer style={{ gap: marginSM }}>
                
                {/* email */}
                <Field
                    name="email"
                    title={__`email`}
                    placeholder={__`email_sample`}
                    disabled={disableEmail}
                    component={FormInput}
                />

                {!hideRest && (

                    <>

                        {/* firstName */}
                        <NullableField
                            name="firstName"
                            title={__`first_name`}
                            placeholder={__`name_sample`}
                            component={FormInput}
                        />
                        
                        {/* lastName */}
                        <NullableField
                            name="lastName"
                            title={__`last_name`}
                            placeholder={__`last_name_sample`}
                            component={FormInput}
                        />

                        {/* language */}
                        <Field
                            name="locale"
                            type="select"
                            title={__`language`}
                            options={adminLanguageOptions}
                            component={FormSelect}
                            notFoundContent={<NotFound/>}
                            showSearch
                            filterOption={(input: string, option: { value: string, label: string}) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                        />

                    </>
                )}

            </VerticalContainer>

        </FormSection>
    )

}
